import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import * as FormStructure from '../FormStructure';
import { TmntText } from '../Common';
import { ERROR_MESSAGE, LOADING_MESSAGE } from '../Messages/Messages';
import DefaultAddress from '../CheckoutInfoBlock/DefaultAddress';
import { MY_ADDRESS_QUERY } from './operations';

export default function MyAddress({ hasProfileCompletionEnabled }) {
  const { loading, error, data } = useQuery(MY_ADDRESS_QUERY, {
    context: { batch: true },
  });

  if (loading) return LOADING_MESSAGE;
  if (error) return ERROR_MESSAGE;

  const {
    addressCardTitle,
    addressCardDefault,
    changeText,
    noDefaultAddress,
    selectAddress,
    addAddress,
    myInfoAddress,
    myInfoAddressDescription,
  } = data.textFor;

  const {
    getDefaultAddress: defaultAddress,
    getAddressPageURL: addressPageURL,
  } = data;

  return (
    <FormStructure.FormGroup>
      <FormStructure.FormCell>
        <div className="my-address__header">
          <TmntText classNames="h4" tmnt={myInfoAddress} />
        </div>
        <div className="my-address__subheader">
          <TmntText tmnt={myInfoAddressDescription} />
        </div>
      </FormStructure.FormCell>

      <FormStructure.FormCell>
        <DefaultAddress
          address={defaultAddress}
          cardTitle={addressCardTitle}
          cardDefaultText={addressCardDefault}
          changeText={changeText}
          noDefaultAddress={noDefaultAddress}
          pageLink={addressPageURL}
          selectAddressText={selectAddress}
          addAddressText={addAddress}
          hasProfileCompletionEnabled={hasProfileCompletionEnabled}
        />
      </FormStructure.FormCell>
    </FormStructure.FormGroup>
  );
}

MyAddress.propTypes = { hasProfileCompletionEnabled: PropTypes.bool };
MyAddress.defaultProps = { hasProfileCompletionEnabled: false };
